<template>
  <div class="rose-wrap">
    <div id="centerRoseChart" style="width:100%;height:100%;"></div>
  </div>
</template>

<script>
const echarts = require("echarts");
export default {
  props: {
    data: { type: Array, default: () => [] }
  },
  data() {
    return {};
  },
  watch: {
    data(v) {
      this.drawRose(v);
    }
  },
  mounted() {
    this.drawRose(this.data);
  },
  methods: {
    drawRose(data) {
      const el = document.getElementById("centerRoseChart");
      if (!el) return;
      let myChart = echarts.getInstanceByDom(el) || echarts.init(el);
      // 数据 = 进程内存占比（与左侧「进程内存 TOP8」同源，配套呼应）
      const rows =
        data && data.length
          ? data
          : [{ name: "暂无数据", value: 1 }];
      myChart.setOption({
        color: [
          "#37a2da",
          "#32c5e9",
          "#9fe6b8",
          "#ffdb5c",
          "#ff9f7f",
          "#fb7293",
          "#e7bcf3",
          "#8378ea"
        ],
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c}%"
        },
        series: [
          {
            name: "进程内存占比",
            type: "pie",
            radius: [16, 62],
            center: ["50%", "50%"],
            roseType: "area",
            itemStyle: {
              borderRadius: 3,
              borderColor: "#0f1325",
              borderWidth: 1
            },
            label: {
              show: true,
              formatter: "{b}\n{d}%",
              fontSize: 10,
              lineHeight: 12,
              color: "#c3cbde"
            },
            labelLine: {
              length: 5,
              length2: 3,
              lineStyle: { color: "rgba(195,203,222,0.45)" }
            },
            data: rows
          }
        ]
      });
      window.addEventListener("resize", () => myChart.resize(), false);
    }
  },
  destroyed() {
    window.onresize = null;
  }
};
</script>

<style lang="scss" scoped>
.rose-wrap {
  flex: 1;
  min-height: 0;
  width: 100%;
}
</style>
